import React from 'react';
import { useSelector } from 'react-redux';
import { getFormattedPrice } from '/Foundation/Common/code/Utils/Utils';

const OrderSummary = () => {
  const cart = useSelector((state) => state.Cart);
  const cartPageData = useSelector((state) => state.CartPageData);

  const { subtotal, shippingInfo, taxTotal, discountAmount, discountLimitError, total, currencyCode } = cart;
  return (
    <div className="order-summary mb-7">
      <div className="sub-cost-section">
        <div className="summary-row">
          <div className="paragraph--s">{cartPageData.subtotal}</div>
          <div className="paragraph--s text-color--gray80">{getFormattedPrice(subtotal, currencyCode)}</div>
        </div>
        {cartPageData.showDelivery && (
          <div className="summary-row">
            <div className="paragraph--s">{cartPageData.estimatedShipping}</div>
            <div className="paragraph--s text-color--gray80">
              {shippingInfo?.id || shippingInfo?.price != null ? (
                <>
                  {shippingInfo?.originalPrice > shippingInfo?.price && (
                    <span className="line-through-text text-color--gray60 me-3">
                      {getFormattedPrice(shippingInfo?.originalPrice, currencyCode)}
                    </span>
                  )}
                  {shippingInfo?.price > 0 ? getFormattedPrice(shippingInfo?.price, currencyCode) : cartPageData.free}
                </>
              ) : (
                '-'
              )}
            </div>
          </div>
        )}
        {cartPageData.showTax && (
          <div className="summary-row">
            <div className="paragraph--s">{cartPageData.estimatedTax}</div>
            <div className="paragraph--s text-color--gray80">
              {taxTotal !== null && taxTotal >= 0 ? getFormattedPrice(taxTotal, currencyCode) : '-'}
            </div>
          </div>
        )}
        {discountAmount > 0 && (
          <div className={discountLimitError ? 'summary-row discount-limit-error' : 'summary-row'}>
            <div>{cartPageData.discount}</div>
            <div className="paragraph--s text-color--gray80">-{getFormattedPrice(discountAmount, currencyCode)}</div>
          </div>
        )}
      </div>
      <div className="summary-row total mt-5">
        <div className="heading5">{cartPageData.total}</div>
        <div className="heading5">{getFormattedPrice(total, currencyCode)}</div>
      </div>
      {cartPageData.showVAT && <span className="text-color--gray60 paragraph--xs">{cartPageData.includingVAT}</span>}
    </div>
  );
};

export default OrderSummary;
